package org.vreo.devicehub.features.core.domain.device.roi

import com.benasher44.uuid.uuid4
import androidx.compose.ui.geometry.Offset

/**
 * ROI (Region of Interest)
 *
 * @property id item/object id. Used for identification for kotlin and ui operations.
 * @property label bay identifier label
 * @property frameHeight pixel height of image used for ROI
 * @property frameWidth pixel width of image used for ROI
 * @property points ROI normalized-coordinates. instead of pixels, they represent percentage of total width and high
 *  - Index 0: Top Left
 *  - Index 1: Top Right
 *  - Index 2: Bottom Right
 *  - Index 3: Bottom Left
 */
data class Roi(
    val id: Int = uuid4().hashCode(),
    val label: String = "",
    val frameHeight: Int = 1080,
    val frameWidth: Int = 1920,

    val points: List<Offset> = listOf(
        Offset(0.1f, 0.1f),
        Offset(0.4f, 0.1f),
        Offset(0.4f, 0.4f),
        Offset(0.1f, 0.4f)
    )
)